import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { WebSocketProvider } from './components/WebSocketContext';
import { SnackbarProvider } from './Utils/SnackBarContext';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import FileViewerProvider from './components/Viewer/FileViewerProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <WebSocketProvider>
      <FileViewerProvider>
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </FileViewerProvider>
    </WebSocketProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
